import { CardSearchOutlineIcon } from './CardSearchOutlineIcon';

/**
 * author: Google
 * id 3EE58157-57AF-420D-9F5B-C545BCE7D395
 * name card-search-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-search-outline.svg
 * tags
 */
export const PageviewOutlineIcon = CardSearchOutlineIcon;
export default PageviewOutlineIcon